import React, { Fragment } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { FulfillmentNote, OrderOrFulfillmentNote } from 'types/schema';
import LoadingIndicator from '../LoadingIndicator';
import LegacyOrderRow from './LegacyOrderRow';
import OrderRow from './OrderRow';

const OrderBody = ({ children }: { children: JSX.Element | JSX.Element[] }) => <div>{children}</div>;

const getOrderKey = (order: OrderOrFulfillmentNote, index: number) => {
  if (order.__typename === 'Order') {
    return order.id;
  }
  if (order.__typename === 'FulfillmentNote') {
    return order.fulfillmentNoteId;
  }
  return index;
};

interface OrderTableProps {
  orders: (OrderOrFulfillmentNote & { loading: boolean })[];
  permissions?: string[];
  onApproveOrder?: (data: any) => void;
  onDisapproveOrder?: (data: any) => void;
  onReOrderAll?: (data: any) => void;
  onBulkReOrder?: (data: any) => void;
  onOpenModal?: (data: FulfillmentNote) => void;
  hasMore?: boolean;
  loading?: boolean;
  onLoadMore?: () => void;
  statuses?: string | string[];
  selectedOrderIds?: string[];
  onSelectOrder?: (orderId: string, checked: boolean) => void;
}

const OrderTable = ({
  orders,
  permissions,
  onApproveOrder,
  onDisapproveOrder,
  onReOrderAll,
  onBulkReOrder,
  onOpenModal,
  hasMore = false,
  onLoadMore,
  statuses,
  selectedOrderIds = [],
  onSelectOrder,
}: OrderTableProps) => {
  return (
    <Fragment>
      <InfiniteScroll
        dataLength={orders.length}
        next={onLoadMore || (() => {})}
        hasMore={hasMore || false}
        loader={<LoadingIndicator />}
        scrollThreshold={0.8}
        style={{ overflow: 'visible' }}
      >
        <OrderBody>
          {orders.map((order, index) =>
            window.location.pathname === '/orders' ? (
              <OrderRow
                key={getOrderKey(order, index)}
                order={order}
                permissions={permissions || []}
                onApproveOrder={onApproveOrder}
                onDisapproveOrder={onDisapproveOrder}
                onReOrderAll={onReOrderAll}
                onBulkReOrder={onBulkReOrder}
                onOpenModal={onOpenModal}
                statuses={statuses}
                selectedOrderIds={selectedOrderIds}
                onSelectOrder={onSelectOrder}
              />
            ) : (
              <LegacyOrderRow key={index} order={order} />
            ),
          )}
        </OrderBody>
      </InfiniteScroll>
    </Fragment>
  );
};

export default OrderTable;
